/**
 * i18n key and values for the "presentation(s) added to folder" snackbar (BA-19255).
 * Used when dragging presentations onto a folder so the toast shows the correct count.
 */

export const ADD_TO_FOLDER_SNACKBAR_KEYS = {
    singular: "{{count}} presentation was added to <folderLink>{{folderName}}</folderLink>",
    plural: "{{count}} presentations were added to <folderLink>{{folderName}}</folderLink>",
} as const;

export interface AddToFolderSnackbarProps {
    i18nKey: string;
    values: { count: number; folderName: string };
}

/**
 * Returns the i18n key and values for the add-to-folder snackbar message.
 * - 1 presentation → "1 presentation was added to [folder name]"
 * - N presentations → "N presentations were added to [folder name]"
 */
export function getAddToFolderSnackbarProps(count: number, folderName: string): AddToFolderSnackbarProps {
    const i18nKey = count === 1 ? ADD_TO_FOLDER_SNACKBAR_KEYS.singular : ADD_TO_FOLDER_SNACKBAR_KEYS.plural;
    return {
        i18nKey,
        values: { count, folderName },
    };
}
